import { Timestamp } from 'firebase/firestore';

const normalizeDate = (date?: Date | string | number | Timestamp) => {
    if (!date) return new Date();

    if (date instanceof Timestamp) {
        return new Date(date.toMillis());
    }

    return new Date(date);
};

export default normalizeDate;
